<template>
  <div class="banner-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first"><h3>{{$t('banner.banner')}}</h3></strong>
            </div>

            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('banner.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-15">
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('banner.basic_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row" >
                    <legend class="col-sm-2 col-form-label">{{$t('banner.name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <b-form-input type="text"
                                    :name="`name[${lang}]`"
                                    class="form-control border-radius-4px"
                                    v-model="item.name[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                      />
                    </div>
                  </div>
                  <div class="form-group row" >
                    <legend class="col-sm-2 col-form-label">{{$t('banner.description')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <count-text-area v-model="item.description[lang]" :placeholder="$t('common.text_' + lang)">
                      </count-text-area>
                    </div>
                  </div>
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('banner.position')}}</legend>
                    <div class="col-sm-5">
                      <b-form-select  class="form-control border-radius-4px"
                                      v-model="item.position_uuid"
                                      :options="positions[$session.get('lang')]"
                                      v-bind:placeholder="$t('banner.position')" />
                    </div>
                  </div>
                  <b-form-group v-bind:label="$t('banner.display_period')" :label-cols="2" :horizontal="true" >
                    <div role="group" class="input-group">
                      <date-picker-input
                        :hasTime="true"
                        className="form-control col-sm-3 float-left border-radius-4px"
                        name="date"
                        type="datetime"
                        v-model="item.date_from"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY HH:mm:ss"
                        formatOutput="DD-MM-YYYY HH:mm:ss"
                        :minDate="formatDisplayDate($moment(new Date(),'DD-MM-YYYY').format('DD-MM-YYYY'))"
                        :change="(e) => item.date_from = e"

                      />
                      <div class="input-group-append">
                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                      </div>
                      <date-picker-input
                        :hasTime="true"
                        className="form-control col-sm-3 float-left border-radius-4px"
                        name="date"
                        type="datetime"
                        v-model="item.date_to"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY HH:mm:ss"
                        formatOutput="DD-MM-YYYY HH:mm:ss"
                        :minDate="formatDisplayDate($moment(new Date(),'DD-MM-YYYY').format('DD-MM-YYYY'))"
                        :change="(e) => item.date_to = e"
                      />
                    </div>
                  </b-form-group>
                  <div class="form-group row">
                    <legend v-if="banner && (banner.config.opening_times || banner.config.special_dates)" class=" col-sm-2 col-form-label">{{$t('banner.fix_banner')}}</legend>
                          <div class="col-sm-5" v-if="banner && (banner.config.opening_times || banner.config.special_dates)">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                            v-model="fix_banner" :value="1" :uncheckedValue="0"/>
                          </div>
                  </div>
                  <b-col cols="12" v-if="fix_banner">
                    <div class="form-group row m-t-20" >
                      <legend class="col-sm-2 col-form-label"></legend>
                      <b-card header-tag="header" class="col-sm-10 none-border" footer-tag="footer" body-class="p-3" v-if="banner && (banner.config.opening_times || banner.config.special_dates) && fix_banner">
                        <div slot="header">
                          <strong class="uppercase">{{ $t('banner.day_part') }}</strong>
                        </div>
                        <b-row>
                          <!-- Part of Days of Week -->
                          <b-col cols="4" v-if="banner && banner.config.opening_times && dataDayPart">
                            <b-form-group  :label-cols="2" :horizontal="true" v-for="dayPart in dataDayPart" :key="dayPart.day" v-bind:label="$t('common.' + dayPart.day)">
                              <div role="group" class="input-group" >
                                <a href="javascript:void(0)" class="reset-custom" @click="resetTime(dayPart)">
                                  {{ $t('banner.reset') }}
                                </a>
                                <div class="input-group-append">
                                  <div class="input-group-text">
                                    <b-form-checkbox v-model="dayPart.active" :value="1" :unchecked-value="0"></b-form-checkbox>
                                  </div>
                                </div>
                                <date-picker-input
                                  className="form-control col-sm-6 float-left"
                                  name="date"
                                  type="time"
                                  v-model="dayPart.opening"
                                  :lang="$session.get('lang')"
                                  :hasPicker="true"
                                  formatInput="HH:mm:ss"
                                  formatOutput="HH:mm:ss"
                                  :change="(e) => dayPart.opening = e"
                                />
                                <div class="input-group-append">
                                  <div class="input-group-text"><i class="fa fa-minus"></i></div>
                                </div>
                                <date-picker-input
                                  :className="'form-control col-sm-6 float-left opening-border-' + dayPart.day"
                                  name="date"
                                  type="time"
                                  v-model="dayPart.closing"
                                  :lang="$session.get('lang')"
                                  :hasPicker="true"
                                  formatInput="HH:mm:ss"
                                  formatOutput="HH:mm:ss"
                                  :change="(e) => dayPart.closing = e"
                                />
                              </div>
                            </b-form-group>
                            <tr>
                              <td colspan="6" class="button-left">
                                <button type="button" class="btn bg-main border-radius-4px" v-on:click="checkOpeningTime">{{$t('banner.check')}}</i></button>
                              </td>
                            </tr>
                          </b-col>
                          <!-- End of Days of Week -->
                
                          <!-- Part of Special Date -->
                          <b-col cols="8" v-if="banner.config.special_dates && special_dates">
                            <b-form-group :label-cols="11" v-bind:label="$t('banner.exception_date')">
                              <table class="table table-bordered table-hover table-text">
                                <thead>
                                <tr>
                                  <th class="hide">{{$t('banner.exception_table_name')}}</th>
                                  <th>{{$t('banner.exception_table_date')}}</th>
                                  <th>{{$t('banner.exception_table_time')}}</th>
                                  <th>{{$t('banner.open')}}</th>
                                  <th>{{$t('common.action')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(date, index) in special_dates" :key="date.id">
                                  <td class="hide">
                                    <b-form-input class="form-control" v-model="special_dates[index].name">
                                    </b-form-input>
                                  </td>
                                  <td>
                                    <date-picker-input
                                      :className="'form-control col-sm-10 float-left date-border-'+index"
                                      name="date"
                                      type="date"
                                      v-model="special_dates[index].date"
                                      :lang="$session.get('lang')"
                                      :hasPicker="true"
                                      formatInput="DD-MM-YYYY"
                                      formatOutput="DD-MM-YYYY"
                                      :minDate="minDate"
                                      :maxDate="maxDate"
                                      :change="(e) => special_dates[index].date = e"
                                    />
                                  </td>
                                  <td>
                                    <div role="group" class="input-group">
                                      <date-picker-input
                                        :className="'form-control col-sm-6 float-left time-from-border-'+index"
                                        name="date"
                                        type="time"
                                        v-model="special_dates[index].from"
                                        :lang="$session.get('lang')"
                                        :hasPicker="true"
                                        formatInput="HH:mm:ss"
                                        formatOutput="HH:mm:ss"
                                        @change="() => checkDatePart()"
                                        :change="(e) => special_dates[index].from = e"
                                      />
                                      <div class="input-group-append">
                                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                                      </div>
                                      <date-picker-input
                                        :className="'form-control col-sm-6 float-left time-to-border-'+index"
                                        name="date"
                                        type="time"
                                        v-model="special_dates[index].to"
                                        :lang="$session.get('lang')"
                                        :hasPicker="true"
                                        formatInput="HH:mm:ss"
                                        formatOutput="HH:mm:ss"
                                        :change="(e) => special_dates[index].to = e"
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="special_dates[index].active" :checked="special_dates[index].active" :value="1" :uncheckedValue="0"/>
                                  </td>
                                  <td>
                                    <b-button class="btn btn-transparent text-main border-radius-4px delete-date" v-on:click="removeSpecialDate(index)" size="sm"><i class="fa fa-trash-o"></i></b-button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="6" class="button-left">
                                    <button type="button" class="btn bg-main border-radius-4px" v-on:click="addSpecialDate"><i class="fa fa-plus"></i></button>
                                    <button type="button" class="btn bg-main border-radius-4px" v-on:click="checkDatePart">{{$t('banner.check')}}</i></button>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </b-form-group>
                          </b-col>
                          <!-- End of Special Date -->
                        </b-row>
                      </b-card>
                    </div>
                  </b-col>
                 


                </b-col>
                <b-col cols="12" class="row m-0 p-0 " >
                  <div class="col-sm-6 row pt-3 m-0 p-0" v-for="(data, ite, index) in item.url" :key="data.id">
                    <legend class="col-sm-4 col-form-label" :class="{'text-right': (index % 2)}">
                      {{$t('banner.url_'+ite)}}
                    </legend>
                    <div class="col-sm-8 ">
                      <b-form-input
                        class="form-control border-radius-4px"
                        v-model="item.url[ite]"
                      />
                    </div>
                  </div>
                </b-col>
                <b-col cols="12" class="row m-0 p-0 " >
                  <div class="col-sm-6 row pt-3 m-0 p-0" v-for="(data, image, index) in imageData" :key="`${image}-${imageDataKey}`" :class="{'hide': image == 'desktop_detail'}">
                  <legend class="col-sm-4 col-form-label" :class="{'text-right': (index % 2)}">
                    {{$t('banner.'+image)}}
                    <!-- <i class="fa fa-info-circle text-primary" :id="'image-' + image"></i> -->
                    <b-tooltip :target="'image-' + image" placement="top">
                      <div class="text-left" v-html="getImageHelpInfo('banner', image)"></div>
                    </b-tooltip>
                  </legend>
                  <div class="col-sm-8 ">
                    <div class='message-text'>
                      {{isMessage}}
                      <ul v-if="isMessage" class="pl-20">
                        <li>{{$t(`banner.dimension-${image}`)}}</li>
                      </ul>
                    </div>

                    <b-form-file :id="image" @change="previewImage" accept="image/*" :placeholder="$t('message.choose_a_image')"></b-form-file>
                  </div>
                  <div v-bind:class="'image-' + image + '-preview img-min-height'" class="col-sm-8 offset-sm-4">
                    <img class="preview-image" v-bind:src="data">
                  </div>
                </div>
                </b-col>
                
              </b-form>
            </b-collapse>
            <div slot="footer">
              <div class="back-button">
                <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.push({name: 'banner', query: {rollback: 1}})"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              </div>
              <div class="btn-save">
                <button type="button" class=" pull-right btn bg-main border-radius-4px pl-3 pr-3" v-on:click="saveBanner()" :disabled="checkSubmit() "> {{$t('common.save')}}</button>
              </div>
             </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import {required} from 'vuelidate/lib/validators'
  import vSelect from 'vue-select'
  import MaskedInput from 'vue-text-mask'
  import cSwitch from '../../../components/Switch'
  import CustomizeField from '../../../components/Partials/CustomizeField'
  import CountTextArea from '../../../components/Partials/CountTextArea'
  import DatePickerInput from '@/components/Partials/DatePickerInput'

  let vm = null
  var defaultDateFrom = '01-01-2018 00:00:00'
  var defaultDateTo = '30-12-9998 23:59:00'
  export default {
    name: 'BannerForm',
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    components: {
      vSelect,
      MaskedInput,
      SelectDropdown,
      CustomizeField,
      CountTextArea,
      cSwitch,
      DatePickerInput
    },
    data: function () {
      return {
        images: ['desktop', 'mobile'],
        mapping: {
          image_desktop: 'desktop',
          image_mobile: 'mobile'
        },
        dataDayPart: [],
        basicInformationStatus: true,
        positions: [],
        imageData: {},
        uploadImageUrl: '',
        imageDataKey: 0,
        item: {
          id: null,
          uuid: '',
          position_uuid: '',
          url: {
            'desktop': '',
            'mobile': ''
          },
          name: {},
          name_seo: {},
          description: {},
          image: {},
          active: 1,
          opening_times: [],
          special_dates: []
        },
        daysOfWeek: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'pub'],
        banner: this.$store.getters.config.gms.banner,
        special_dates: [],
        opening_times: {},
        fix_banner: false,
        minDate: '',
        maxDate: '',
        delete_special_dates: [],
        timezone: this.$store.getters.config.main.timezone ? this.$store.getters.config.main.timezone : '',
        isMessage: '',
        imgSizeMaximumError: ''
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        name: {
          required
        },
        position_uuid: {
          required
        }
      }
    },
    methods: {
      // day part
      /**
       * format item.date_from item.date_to
       */
      formatDisplayDate(date) {
        let day = this.$moment(date,'DD-MM-YYYY').format('DD');
        let month = this.$moment(date,'DD-MM-YYYY').format('MM');
        let year = this.$moment(date,'DD-MM-YYYY').format('YYYY');
        return new Date(year, month - 1, day)
      },
      /**
       * add special date to list with default attribute
       */
      addSpecialDate () {
        this.special_dates.push({
          name: '',
          from: '00:00:00',
          to: '23:59:59',
          date: this.$moment().format('DD-MM-YYYY'),
          status: 1,
          active: 1
        })
      },
      /**
       * remove special date from list
       * @param index
       */
      removeSpecialDate (index) {
        let dates = []

        for (let i in this.special_dates) {
          if (i != index) {
            dates.push(this.special_dates[i])
          } else if (this.special_dates[i].id) {
            vm.delete_special_dates.push(this.special_dates[i].id)
          }
        }

        this.special_dates = dates
      },
      /**
       * convert date from YYYY-MM-DD to DD-MM-YYYY
       * @param val
       * @returns {*}
       */
      convertDateFormat (val) {
        // val = this.convertUTCToClientTime(val)
        return this.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
      },
      /**
       * revert date from DD-MM-YYYY to YYYY-MM-DD
       * @param val
       * @returns {*}
       */
      revertDateFormat (val) {
        let formatDate = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
        return formatDate
      },
      revertBaseDateFormat(val){
        return this.$moment(val, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      },
      createNewDateTime(y, m, d, h=0, mm=0, s=0) {
        return new Date(y, m, d, h, mm, s)
      },
      checkDatePart () {
        let checkDate = true
        let dateFrom = vm.$moment(vm.item.date_from, "DD-MM-YYYY HH:mm:ss")
        let newDateFrom = this.createNewDateTime(dateFrom.year(), dateFrom.month() - 1 , dateFrom.date())
        let newTimeFrom = this.createNewDateTime(dateFrom.year(), dateFrom.month() - 1 , dateFrom.date(), dateFrom.hours(), dateFrom.minute(), dateFrom.second())

        let dateTo = vm.$moment(vm.item.date_to, "DD-MM-YYYY HH:mm:ss")
        let newDateTo = this.createNewDateTime(dateTo.year(), dateTo.month() - 1 , dateTo.date())
        let newTimeTo = this.createNewDateTime(dateTo.year(), dateTo.month() - 1 , dateTo.date(), dateTo.hours(), dateTo.minute(), dateTo.second())


        for (let index = 0; index < vm.special_dates.length; index++) {
          let special_date = vm.special_dates[index];
          // if(!special_date.active) continue
          let specicalDate =  vm.$moment(special_date.date , "DD-MM-YYYY")
          let specicalTimeFrom =  vm.$moment(special_date.from, "HH:mm:ss")
          let specicalTimeTo =  vm.$moment(special_date.to, "HH:mm:ss")

          let newSpecicalDate = this.createNewDateTime(specicalDate.year(), specicalDate.month() - 1 , specicalDate.date())
          let newSpecicalTimeFrom =  this.createNewDateTime(specicalDate.year(), specicalDate.month() - 1, specicalDate.date(), specicalTimeFrom.hours(), specicalTimeFrom.minute(), specicalTimeFrom.second())
          let newSpecicalTimeTo =  this.createNewDateTime(specicalDate.year(), specicalDate.month() - 1, specicalDate.date(), specicalTimeTo.hours(), specicalTimeTo.minute(), specicalTimeTo.second())

          let classDate = document.getElementsByClassName('date-border-'+index)
          if (newSpecicalDate < newDateFrom || newSpecicalDate > newDateTo) {
            if (classDate.length > 0) {
              classDate[0].classList.add('border-red')
              checkDate = false
            }
            
          } else if (classDate.length > 0) {
            classDate[0].classList.remove('border-red')
          }

          let classTimeFrom = document.getElementsByClassName('time-from-border-'+index)
          if ((!(newSpecicalDate > newDateFrom) && !(newSpecicalDate < newDateFrom)) && (newSpecicalTimeFrom < newTimeFrom )) {
            if (classTimeFrom.length > 0) {
              classTimeFrom[0].classList.add('border-red')
              checkDate = false
            }
            
          } else if (classTimeFrom.length > 0) {
            classTimeFrom[0].classList.remove('border-red')
          }

          let classTo = document.getElementsByClassName('time-to-border-'+index)
          if ((!(newSpecicalDate > newDateTo) && !(newSpecicalDate < newDateTo)) && (newSpecicalTimeTo > newTimeTo )) {
            if(classTo.length > 0) {
              classTo[0].classList.add('border-red')
              checkDate = false
            }
          } else if (classTo.length > 0) {
            classTo[0].classList.remove('border-red')
          }
          if (newSpecicalTimeTo < newSpecicalTimeFrom) {
            if(classTo.length > 0) {
              classTo[0].classList.add('border-red')
              checkDate = false
            }
          }
        }
        return checkDate
      },
      resetTime(dayPart) {
        dayPart.opening = '00:00:00'
        dayPart.closing = '23:59:59'
      },
      checkOpeningTime() {
        let vm= this
        let checkDate = true
        let today = vm.$moment(new Date()).format('DD-MM-YYYY')
        for (let key in vm.dataDayPart) {
          const opening = vm.dataDayPart[key];
          let openingFrom =  vm.$moment(opening.opening, "HH:mm:ss")
          let openingTo =  vm.$moment(opening.closing, "HH:mm:ss")

          let classTimeFrom = document.getElementsByClassName('opening-border-'+vm.dataDayPart[key].day)
          if ((openingTo < openingFrom )) {
            if (classTimeFrom.length > 0) {
              classTimeFrom[0].classList.add('border-red')
              checkDate = false
            }
            
          } else if (classTimeFrom.length > 0) {
            classTimeFrom[0].classList.remove('border-red')
          }
        }
        return checkDate;
      },
      //---end day part
      checkSubmit: function () {
        let validateName = false
        let form = vm.$v.item.$invalid
        return form || validateName
      },
      checkDSTTimeSpecial(special_dates, isSave = false) {
        for(let i of special_dates){
          const convertDateTimeFrom = ''
          const convertDateTimeTo = ''
          const dateTimeFrom = vm.revertDateFormat(i.date)+ ' ' + i.from
          const dateTimeTo = vm.revertDateFormat(i.date)+ ' ' + i.to
          
          const checkDST = vm.checkDSTTime(dateTimeFrom,vm.timezone)

          convertDateTimeFrom = vm.convertDateTimeFromTimezoneToUTC(dateTimeFrom, vm.timezone)
          convertDateTimeTo = vm.convertDateTimeFromTimezoneToUTC(dateTimeTo, vm.timezone)
          
          if (!isSave) {
            convertDateTimeFrom = vm.convertUTCToTimeZone(i.date+ ' ' + i.from, vm.timezone)
            convertDateTimeTo = vm.convertUTCToTimeZone(i.date+ ' ' + i.to, vm.timezone)

          } 
          
          i.date = convertDateTimeFrom.format(isSave ? 'YYYY-MM-DD': 'DD-MM-YYYY')
          i.from = convertDateTimeFrom.format('HH:mm:ss')
          i.to = convertDateTimeTo.format('HH:mm:ss')
        }
        return special_dates
      },
      checkDSTOpeningTime(opening_times, isSave = false) {
        let todayNew = vm.$moment(new Date()).format('YYYY-MM-DD')
        for(let i in opening_times) {
          const openingTime = opening_times[i];
          const checkDSTOpening = vm.checkDSTTime(vm.revertBaseDateFormat(todayNew + ' ' + openingTime.opening),vm.timezone)
          const checkDSTClosing = vm.checkDSTTime(vm.revertBaseDateFormat(todayNew + ' ' + openingTime.closing),vm.timezone)
          openingTime.opening = checkDSTOpening
                                ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + openingTime.opening, vm.timezone).add(1, 'hours').format('HH:mm:ss') 
                                : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + openingTime.opening, vm.timezone).format('HH:mm:ss')
          openingTime.closing = checkDSTClosing
                                ? vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + openingTime.closing, vm.timezone).add(1, 'hours').format('HH:mm:ss') 
                                : vm.convertDateTimeFromTimezoneToUTC(todayNew + ' ' + openingTime.closing, vm.timezone).format('HH:mm:ss')
          // if (!isSave) {

          // }
        }
        return opening_times
      },
      saveBanner () {
        var data = JSON.parse(JSON.stringify(vm.item))
        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.item.image) {
          if (vm.item.image[i] && vm.item.image[i].type != undefined) {
            formData.append('image_' + i, vm.item.image[i])
          } else {
            oldUrl[i] = vm.item.image[i]
          }
        }
        
        // daypart banner
          if((vm.banner && vm.banner.config.special_dates && !this.checkDatePart()) || (vm.banner && vm.banner.config.opening_times && !this.checkOpeningTime())) return
          //special_dates
          if (vm.banner && vm.banner.config.special_dates && vm.fix_banner) {
            vm.special_dates = vm.special_dates.filter((special_date, index) => vm.special_dates.findIndex((item) => item.date === special_date.date && item.from === special_date.from && item.to === special_date.to) === index)
            let special_dates = JSON.parse(JSON.stringify(vm.special_dates))
            
            for(let i of special_dates){
              i.date = vm.revertDateFormat(i.date)
            }
            
            data.special_dates = special_dates//vm.checkDSTTimeSpecial(special_dates, true)
          } else {
            data.special_dates = []
          }
          
          //opening_times
          if (vm.banner && vm.banner.config.opening_times && vm.fix_banner) {
            // console.log('dataDayPart', vm.dataDayPart)
            for (let i = 0; i < vm.dataDayPart.length; i++) {
              const element = vm.dataDayPart[i];
              vm.opening_times[element.day].opening = element.opening
              vm.opening_times[element.day].closing = element.closing
              vm.opening_times[element.day].active = element.active
            }
            data.opening_times = vm.opening_times//vm.checkDSTOpeningTime(vm.opening_times)

          } else {
            data.opening_times = {}
          }
          
          //delete_special_dates
          if (vm.banner && vm.banner.config.opening_times && vm.fix_banner) {
            data.delete_special_dates = vm.delete_special_dates
          } else {
            data.delete_special_dates = {}
          }
          
          //config
          data.type = vm.fix_banner
          data.timezone = vm.timezone
          if(data.url) {
            if (data.url.desktop && data.url.desktop.slice(-1) === '/') {
              // remove all "/" in the end of string
              let isStop = false
              for (let i = data.url.desktop.length - 1; i > 0; i --) {
                if(!isStop && data.url.desktop[i] !== '/') {
                  isStop = true
                } else if(!isStop) {
                  data.url.desktop = data.url.desktop.slice(0, -1)
                }
              }
            }
            if (data.url.mobile && data.url.mobile.slice(-1) === '/') {
              // remove all "/" in the end of string
              let isStop = false
              for (let i = data.url.mobile.length - 1; i > 0; i --) {
                if(!isStop && data.url.mobile[i] !== '/') {
                  isStop = true
                } else if(!isStop) {
                  data.url.mobile = data.url.mobile.slice(0, -1)
                }
              }
            }
          }
        //------
        for (let i in vm.positionList) {
          if (this.item.position_uuid == vm.positionList[i].uuid) {
            data.position_code = vm.positionList[i].code
          }
        }
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        
        vm.axios.banner.uploadBannerImages(formData, config, function (response) {
          data.image = {}
          for (let i in response.data.data.item) {
            data.image[vm.mapping[i]] = response.data.data.item[i]
          }
          for (let i in oldUrl) {
            data.image[i] = oldUrl[i]
          }
          delete data.image['image_mobile']
          delete data.image['image_desktop']
          vm.imageData = data.image
          data.date_from = vm.convertDateTimeToUTC(vm.$moment(data.date_from, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'))
          data.date_to = vm.convertDateTimeToUTC(vm.$moment(data.date_to, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'))
          // const checkDSTDateFrom = vm.checkDSTTime(vm.revertBaseDateFormat(data.date_from),vm.timezone)
          // const checkDSTDateTo = vm.checkDSTTime(vm.revertBaseDateFormat(data.date_to),vm.timezone)
          // data.date_from = checkDSTDateFrom
          //                       ? vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(data.date_from), vm.timezone).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss') 
          //                       : vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(data.date_from), vm.timezone).format('YYYY-MM-DD HH:mm:ss')
          // data.date_to = checkDSTDateTo
          //                       ? vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(data.date_to), vm.timezone).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss') 
          //                       : vm.convertDateTimeFromTimezoneToUTC(vm.revertBaseDateFormat(data.date_to), vm.timezone).format('YYYY-MM-DD HH:mm:ss')
          if (vm.item.uuid == '' || vm.item.uuid == 'create') {
            vm.axios.banner.createBanner(data, function (response) {
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              vm.$router.push({'name': 'banner'})
            }, function () {
            })
          } else {
            vm.axios.banner.updateBanner(data, function (response) {
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.$router.push({'name': 'banner'})
            }, function () {
            })
          }
        })
      },
      getBannerDetail() {
        if (vm.uuid === 'create') return
        vm.axios.campaign.getBannerDetail(vm.uuid,
          function (response) {
            let item = response.data.data.item
            if (item.position_code === 'homepage_background') {
              vm.isMessage = vm.$t('banner.image_side_message')
            } else {
              vm.isMessage = ''
            }

            if (item.date_from == '' || item.date_from == 'Invalid date' || item.date_from == '__-__-____') {
              item.date_from = defaultDateFrom
            } else {
              // const checkDSTDateFrom = vm.checkDSTTime(vm.revertBaseDateFormat(item.date_from),vm.timezone)
          
              // item.date_from = checkDSTDateFrom
              //                     ? vm.convertUTCToTimeZone(item.date_from, vm.timezone).subtract(1,'hours').format('DD-MM-YYYY HH:mm:ss')
              //                     : vm.convertUTCToTimeZone(item.date_from, vm.timezone).format('DD-MM-YYYY HH:mm:ss')
              item.date_from = vm.convertUTCToClientTime(item.date_from).format('DD-MM-YYYY HH:mm:ss')
            }

            if (item.date_to == '' || item.date_to == 'Invalid date' || item.date_to == '__-__-____') {
              item.date_to = defaultDateTo
            } else {
              // const checkDSTDateTo = vm.checkDSTTime(vm.revertBaseDateFormat(item.date_to),vm.timezone)
              // item.date_to = checkDSTDateTo
              //                     ? vm.convertUTCToTimeZone(item.date_to, vm.timezone).subtract(1,'hours').format('DD-MM-YYYY HH:mm:ss')
              //                     : vm.convertUTCToTimeZone(item.date_to, vm.timezone).format('DD-MM-YYYY HH:mm:ss')
              item.date_to = vm.convertUTCToClientTime(item.date_to).format('DD-MM-YYYY HH:mm:ss')
            }
            vm.minDate = vm.formatDisplayDate(item.date_from)
            vm.maxDate = vm.formatDisplayDate(item.date_to )
            
            if (item.description == null) {
              item.description = {'ja': '', 'en': ''}
            }

            vm.item = item
            for (let i in vm.images) {
              vm.imageData[vm.images[i]] = vm.item.image[vm.images[i]] != null ? vm.item.image[vm.images[i]] : ''
            }
            for (let i in vm.daysOfWeek) {
              if (!vm.banner.config.public_holiday && vm.daysOfWeek[i] === 'pub') {
                vm.daysOfWeek.splice(i, 1);
                continue
              } 

              vm.dataDayPart.push({
                day: vm.daysOfWeek[i],
                opening: '00:00:00',
                closing: '23:59:59',
                active: 1
              })
              
              vm.opening_times[vm.daysOfWeek[i]] = {
                day: vm.daysOfWeek[i],
                opening: '00:00:00',
                closing: '23:59:59',
                active: 1
              }

              for (let i in vm.item.opening_times) {
                if (vm.item.opening_times[i].day == vm.daysOfWeek[i]) {
                  if (!vm.banner.config.public_holiday && vm.daysOfWeek[i] === 'pub') {
                    vm.item.opening_times.splice(i, 1);
                    continue
                  } 
                  // let todayNew = vm.$moment(new Date()).format('YYYY-MM-DD')
                  // const checkDSTOpening = vm.checkDSTTime(vm.revertBaseDateFormat(todayNew + ' ' + vm.item.opening_times[i].opening),vm.timezone)
                  // const checkDSTClosing = vm.checkDSTTime(vm.revertBaseDateFormat(todayNew + ' ' + vm.item.opening_times[i].closing),vm.timezone)

                  // vm.item.opening_times[i].opening = checkDSTOpening
                  //                                     ? vm.convertUTCToTimeZone(todayNew + ' ' + vm.item.opening_times[i].opening, vm.timezone).subtract(1, 'hours').format('HH:mm:ss') 
                  //                                     : vm.convertUTCToTimeZone(todayNew + ' ' + vm.item.opening_times[i].opening, vm.timezone).format('HH:mm:ss')
                  // vm.item.opening_times[i].closing = checkDSTClosing
                                                      // ? vm.convertUTCToTimeZone(todayNew + ' ' + vm.item.opening_times[i].closing, vm.timezone).subtract(1, 'hours').format('HH:mm:ss') 
                                                      // : vm.convertUTCToTimeZone(todayNew + ' ' + vm.item.opening_times[i].closing, vm.timezone).format('HH:mm:ss')

                  vm.opening_times[vm.item.opening_times[i].day] = {
                    id: vm.item.opening_times[i].id,
                    day: vm.item.opening_times[i].day,
                    opening: vm.item.opening_times[i].opening,
                    closing: vm.item.opening_times[i].closing,
                    active: vm.item.opening_times[i].active
                  }
                }
              }
            }
            for (let i = 0; i < vm.dataDayPart.length; i++) {
              vm.dataDayPart[i].active = vm.opening_times[vm.dataDayPart[i].day].active
              vm.dataDayPart[i].opening = vm.opening_times[vm.dataDayPart[i].day].opening
              vm.dataDayPart[i].closing = vm.opening_times[vm.dataDayPart[i].day].closing
            }
            vm.fix_banner = vm.item.type

            if (vm.item.special_dates.length <= 0 || vm.item.special_dates === null) {
              vm.special_dates = []
            } else {
              vm.special_dates = vm._.cloneDeep(vm.item.special_dates)
              // vm.special_dates = vm.checkDSTTimeSpecial(vm.item.special_dates, false)
              for (let i in vm.special_dates) {
                vm.special_dates[i].date = vm.convertDateFormat(vm.special_dates[i].date)
              }
            }
            
          })

      },
      /**
       * preview image after select
       * @param event
       */
      previewImage (event) {
        let input = event.target
        if (input.files && input.files[0]) {
          // if là position home background và size > 10mb
          if (this.getCodePosition(this.item.position_uuid) === 'homepage_background' && input.files[0].size > 10000000) {
            this.$toastr.error(this.$t('banner.image_size_error'), '', {})
            // this.resetImage(input.id)
          } else {
            let reader = new FileReader()

            reader.onload = (e) => {
              this.imageData[input.id] = e.target.result
            }
            let data = {}
            for (let i in this.images) {
              data[this.images[i]] = this.imageData[this.images[i]]
            }
            this.imageData = data
            reader.readAsDataURL(input.files[0])
            this.item.image[input.id] = input.files[0]
            }
        }
      },
      /**
       * update status of customise session
       */
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
      resetImage(type) {
        this.imageData[type] = ''
        this.item.image[type] = ''
        this.imageDataKey += 1
      },
      getCodePosition (uuid) {
        return (this.positionList && this.positionList.length > 0) ? this.positionList.find((position)=> position.uuid === uuid).code : ''
      },
      getPositions () {
        var vm = this
        vm.axios.banner.getPositionList(function (response) {
          vm.positionList = response.data.data.items
          let langs = vm.$store.getters.languages
          for (let l in langs) {
            vm.positions[langs[l]] = []

            for (let c in response.data.data.items) {
              let item = response.data.data.items[c]

              if (item['name'] != null) {
                vm.positions[langs[l]].push({
                  value: item['uuid'],
                  text: vm.$t('banner.' + item['code'])
                })
              }
            }
          }
          vm.$forceUpdate('positions')
        }, function () {
        })
      }
    },
    created: function () {
      vm = this
      this.getPositions()
      
      },
    mounted: function () {
      vm = this
      vm.timezone = vm.timezone ? vm.timezone 
                                    : (
                                        vm.$const.CLIENT_TIMEZONE[vm.$store.getters.config.base.id] 
                                        ? vm.$const.CLIENT_TIMEZONE[vm.$store.getters.config.base.id] 
                                        : this.$moment.tz.guess()
                                      )
      let today = new Date()
      today = this.$moment(today).format('YYYY-MM-DD')
      defaultDateFrom = this.$moment(today, 'YYYY-MM-DD').format('DD-MM-YYYY HH:mm:ss')
      defaultDateTo = this.$moment(today, 'YYYY-MM-DD').add(1, 'months').hour(23).format('DD-MM-YYYY HH:mm:ss')
      if (vm.uuid == 'create' || vm.uuid == undefined) {
        let data = {}
        for (let i in vm.images) {
          data[vm.images[i]] = ''
        }
        vm.imageData = data
        vm.item.date_from = defaultDateFrom
        vm.item.date_to = defaultDateTo

        vm.minDate = vm.formatDisplayDate(vm.item.date_from)
        vm.maxDate = vm.formatDisplayDate(vm.item.date_to)
        for (let i in vm.daysOfWeek) {
          if (!vm.banner.config.public_holiday && vm.daysOfWeek[i] === 'pub'){ 
            vm.daysOfWeek.splice(i, 1);
            continue
           }
          vm.opening_times[vm.daysOfWeek[i]] = {
            day: vm.daysOfWeek[i],
            opening: '00:00:00',
            closing: '23:59:59',
            active: 1
          }
          
          vm.dataDayPart.push({
            day: vm.daysOfWeek[i],
            opening: '00:00:00',
            closing: '23:59:59',
            active: 1
          })
          
        }
      } else {
        vm.getBannerDetail()
      }
    
      this.$forceUpdate('opening_times')
      this.$forceUpdate('special_dates')
    },
    watch: {
      'item.date_from': function (newVal, oldVal) {
        this.minDate = this.formatDisplayDate(newVal)
        this.checkDatePart()
      },
      'item.date_to': function (newVal, oldVal) {
        this.maxDate = this.formatDisplayDate(newVal)
        this.checkDatePart()
      },
      'item.position_uuid': function (newVal, oldVal) {
        if (this.positionList && this.positionList.length > 0) {
          if (this.getCodePosition(newVal) === 'homepage_background') {
            this.isMessage = this.$t('banner.image_side_message')
            
            if (this.imageData.desktop || this.imageData.mobile) {
              if (this.item.image.desktop && this.item.image.desktop.size && this.item.image.desktop.size > 10000000) {
                this.resetImage('desktop')
              }
              if (this.item.image.mobile && this.item.image.mobile.size && this.item.image.mobile.size > 10000000) {
                this.resetImage('mobile')
              }
            }
          } else {
            this.isMessage = ''
          }
        }
      },
    }
  }
</script>

<style scoped>

  .pl-20 {
    padding-left: 20px !important;
  }

  .message-text {
    font-size: 12px;
    padding-bottom: 5px;
  }

  .error-message {
    color: #f86c6b;
  }

  .reset-custom {
    margin-right: 10px;
    margin-top: 7px;
    color: #0091FF !important;

  }

  .back-button {
    padding-left: 25px;
    width: 95px;
    float: left;
  }

  .table-text {
    text-align: center;
  }

  .button-left {
    text-align: left;
  }

  .switch-customize {
    height: 24px !important;
    border: none;
    background-color: transparent !important;
    margin-bottom: 0px;
  }

  .m-t-20 {
    margin-top: 20px !important;
  }

  .none-border {
    border: 0px solid #d1d4d7 !important;
  }

  .card-body {
    border: 1px solid #d1d4d7 !important;
  }

  .border-red {
    border-color: red;
  }

  .delete-date {
    font-size: 18px;
    font-weight: bold;
  }

  .banner-form .switch.switch-icon{
    margin-top: 5px;
  }

  .banner-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .banner-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .banner-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .banner-form .btn-save{
    float: right !important;
    padding-right: 22px;
    margin-right: 0px !important;
    box-sizing: border-box;
    text-align: right;
  }
  /*END Form Wizard*/
</style>

<style>
  .preview-image {
    width: 100%;
  }

  .banner-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .banner-form div.header,
  .banner-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .banner-form .btn-primary .fa{
    font-size: 20px;
  }
  .banner-form .btn-primary {
    color: #0091ff;
    background-color: transparent;
  }
  .banner-form .btn-primary:hover{
    color: #0091ff;
    background-color: transparent;
  }
  .pt-05{
    padding: 0.5rem;
  }
  .pb-15{
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/banner/BaseForm.vue